import { z } from 'zod';
import { siteSchema } from './site';

export const organizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string(),
  city: z.string(),
  province: z.string(),
  sites: z.lazy(() => siteSchema.array().optional()),
});

export const createOrganizationSchema = organizationSchema.omit({
  sites: true,
});
